import { motion } from 'framer-motion';

export function AnalyzingOverlay({ label = '观微先生正在分析' }: { label?: string }) {
  return (
    <div className="flex min-h-[220px] items-center justify-center rounded-2xl border border-border bg-bg-1 p-5 text-center shadow-gold sm:min-h-[260px] sm:p-8">
      <div>
        <div className="relative mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-border-accent bg-accent-soft sm:h-24 sm:w-24">
          <motion.span
            className="absolute h-full w-full rounded-full border border-accent"
            animate={{ scale: [0.86, 1.16, 0.86], opacity: [0.35, 0.9, 0.35] }}
            transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }}
          />
          <motion.span
            className="absolute h-14 w-14 rounded-full border border-accent sm:h-16 sm:w-16"
            animate={{ scale: [1.1, 0.82, 1.1], opacity: [0.25, 0.85, 0.25] }}
            transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
          />
          <span className="relative font-serif text-3xl text-accent">觀</span>
        </div>
        <p className="mt-5 font-serif text-lg text-fg sm:text-xl">{label}</p>
        <p className="mt-2 text-xs tracking-[0.28em] text-fg-muted">PLEASE WAIT</p>
        <div className="mt-5 flex items-center justify-center gap-2">
          {[0, 1, 2].map((index) => (
            <motion.span
              key={index}
              className="h-2 w-2 rounded-full bg-accent"
              animate={{ y: [0, -6, 0], opacity: [0.35, 1, 0.35] }}
              transition={{ duration: 0.9, repeat: Infinity, delay: index * 0.14 }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
